<div class="modal" [class]="data.type" data-testid="alert-modal">

  <div class="header">
    <div class="header-content">
      <div class="header-content-label">
        <div class="header-content-label-icon">
          <ui-inline-svg class="header-content-label-icon-svg" [name]="getTypeData().icon" />
        </div>
        <span class="header-content-label-title">{{ label | transloco: { params: labelParams } }}</span>
      </div>
      <ui-button-close size="large" (click)="executeAction()" />
    </div>

    <div class="line"></div>
  </div>

  <div class="content">
    <span class="content-title">{{ title | transloco: titleParams }}</span>
    @if (subtitle) {
      <span class="content-description">{{ subtitle | transloco: subtitleParams }}</span>
    }
    
    @if (isPrompt) {
      <div class="content-prompt">
        <input
          type="text"
          class="content-prompt-input"
          data-testid="alert-prompt-input"
          [placeholder]="promptPlaceholder ?? ''"
          [(ngModel)]="promptValue"
        />
      </div>
    }

    @if (data.safeHtml) {
      <div class="content-html" [innerHTML]="data.safeHtml"></div>
    }
  </div>

  <div class="action">
    @for (button of data.buttons; track $index; let i = $index) {
      <ui-button
        size="large"
        [color]="getTypeData().buttonColors || 'onLight'"
        [secondary]="i === 0 || false"
        [disabled]="i === 1 && promptBlank()"
        [attr.data-testid]="i === 0 ? 'alert-cancel-btn' : 'alert-confirm-btn'"
        (click)="executeAction(i)"
        >
        {{ button | transloco }}
      </ui-button>
    }
  </div>

</div>